// extracted by mini-css-extract-plugin
export default {"author":"Author_author__wTyeC","all_authors":"Author_all_authors__MgMn2"};